import { ErrorLogComponent } from '@cian/error-log-component';

import { type FC, useMemo, useRef } from 'react';

import { useMapAppContext } from '@/microfrontends/map/shared/context/mapAppContext';

import { useGetYandexMapScriptQuery } from '@/packages/query-state/shared/store/yandex-map/2.1/get-yandex-map/query';

import { type IMapStoreContext, MapStoreContext } from '../../context/mapStoreContext';
import { useInitYandexMap } from '../../hooks/useInitYandexMap';
import { MapControlsSlotsContainer } from '../MapControlsSlots';
import { MapHTMLContainer } from '../MapHTMLContainer';
import { MapLayersCenter } from '../MapLayersCenter';
import { MapManagers } from '../MapManagers';
import { MapNotificationsContainer } from '../MapNotifications';

import { MapError } from './internal/components/MapError';

export const MapContainer: FC = () => {
  const { logger } = useMapAppContext();

  const { isError, refetch } = useGetYandexMapScriptQuery();

  const mapRef = useRef<HTMLDivElement>(null);

  const { ymaps, map } = useInitYandexMap(mapRef);

  const storeContext = useMemo<IMapStoreContext | null>(() => (ymaps && map ? { ymaps, map } : null), [ymaps, map]);

  if (isError) {
    return <MapError onRetry={refetch} />;
  }

  return (
    <ErrorLogComponent errorStub={<MapError />} level="error" logger={logger}>
      <MapHTMLContainer ref={mapRef} />

      {storeContext && (
        <MapStoreContext.Provider value={storeContext}>
          <MapNotificationsContainer />
          <MapControlsSlotsContainer />
          <MapManagers />
          <MapLayersCenter />
        </MapStoreContext.Provider>
      )}
    </ErrorLogComponent>
  );
};
